module.exports = __webpack_public_path__ + "static/img/publicQR.b02b133.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/menu/publicQR.png
// module id = zqBj
// module chunks = 1